export default "__VITE_ASSET__BpuLkOzz__"